import React from 'react';

// Components
import Anchor from 'Components/common/Anchor';

class NavigationItem extends React.Component {
    name = 'NavigationItem';

    render() {
        let classNameList = ['navigation-item'];

        if(this.props.className) classNameList = ['navigation-item', ...this.props.className.split(' ')];

        return (
            <Anchor className={ classNameList.join(' ') } onClickOfSingleTap={ this.props.onClickOfSingleTap }>{ this.props.children }</Anchor>
        );
    }
}

export default NavigationItem;
